import { Toaster as HotToaster } from 'react-hot-toast';

export function Toaster() {
  return (
    <HotToaster
      position="top-center"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--background)',
          color: 'var(--foreground)',
          border: '1px solid var(--border)',
        },
        success: {
          iconTheme: {
            primary: '#014141',
            secondary: '#fff',
          },
        },
        error: {
          iconTheme: {
            primary: 'hsl(0, 84.2%, 60.2%)',
            secondary: '#fff',
          },
        },
      }}
    />
  );
}
